"use strict";
/**
 * @packageDocumentation
 * @module AuthContextProvider
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthContextProvider = void 0;
var react_1 = __importStar(require("react"));
var context_1 = require("./context");
var react_i18next_1 = require("react-i18next");
var i18nAuthInstance_1 = require("./i18nAuthInstance");
var ErrorContext_1 = require("../ErrorContext");
var AuthDictionaries_1 = require("./AuthDictionaries");
var SharedDictionaries_1 = require("../SharedDictionaries");
var AuthContextProvider = function (props) {
    var _a;
    var i18nInstance = (_a = props.i18n) !== null && _a !== void 0 ? _a : i18nAuthInstance_1.i18nAuthInstance;
    var children = props.children, authContextProps = __rest(props, ["children"]);
    var language = props.language, _b = props.i18n, i18n = _b === void 0 ? i18nInstance : _b, errorConfig = props.errorConfig;
    if (props.i18n) {
        i18n.addResourceBundle('zh', 'bluiAuth', AuthDictionaries_1.AuthDictionaries.chinese.translation, true, false);
        i18n.addResourceBundle('zh', 'bluiCommon', SharedDictionaries_1.SharedDictionaries.chinese.translation, true, false);
        i18n.addResourceBundle('en', 'bluiAuth', AuthDictionaries_1.AuthDictionaries.english.translation, true, false);
        i18n.addResourceBundle('en', 'bluiCommon', SharedDictionaries_1.SharedDictionaries.english.translation, true, false);
        i18n.addResourceBundle('fr', 'bluiAuth', AuthDictionaries_1.AuthDictionaries.french.translation, true, false);
        i18n.addResourceBundle('fr', 'bluiCommon', SharedDictionaries_1.SharedDictionaries.french.translation, true, false);
        i18n.addResourceBundle('pt', 'bluiAuth', AuthDictionaries_1.AuthDictionaries.portuguese.translation, true, false);
        i18n.addResourceBundle('pt', 'bluiCommon', SharedDictionaries_1.SharedDictionaries.portuguese.translation, true, false);
        i18n.addResourceBundle('es', 'bluiAuth', AuthDictionaries_1.AuthDictionaries.spanish.translation, true, false);
        i18n.addResourceBundle('es', 'bluiCommon', SharedDictionaries_1.SharedDictionaries.spanish.translation, true, false);
    }
    (0, react_1.useEffect)(function () {
        void i18n.changeLanguage(language);
    }, [i18n, language]);
    return (react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18n },
        react_1.default.createElement(context_1.AuthContext.Provider, { value: __assign({}, authContextProps) },
            react_1.default.createElement(ErrorContext_1.ErrorContext.Provider, { value: errorConfig }, children))));
};
exports.AuthContextProvider = AuthContextProvider;
